import React, { Component } from 'react';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { notification } from '../../helpers';
moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');



class OrderRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      status: 'valid'
    }
  }

  onDelEvent() {
    if(!this.props.disabled) {
      this.props.onDelEvent(this.props.order);
    } else {
      notification('Kan inte ta bort hjulset som inte är komplett')
    }
  }
  
  render() {
    const { order: { regnr, serienr, bilmodell, hjulmodell, offRentDate, lastOnRentDate, valid } } = this.props;
    const { disabled } = this.props;

    return (
      <tr
        className={this.state.status === 'valid' && disabled ? 'valid' : !valid ? 'valid error' : 'valid'}

        disabled={disabled}
        style={disabled ? {cursor: "default"} : null}
      >
        <td>{regnr}</td>
        <td>{serienr}</td>
        <td>{bilmodell}</td>
        <td>{hjulmodell}</td>
        <td>{moment(offRentDate).format('YYYY-MM-DD - HH:mm')}</td>
        <td>{moment(lastOnRentDate).format('YYYY-MM-DD')}</td>
        <td 
          className={regnr.length >= 6 && serienr.length < 1 ? 'del-cell-loading' : !valid ? 'del-cell-error' : 'del-cell'}
        >
          <input
            style={disabled ? {background: "transparent", cursor: "default"} : null} 
            type="button"
            onClick={this.onDelEvent.bind(this)}
            className="del-btn"
          />
        </td>
      </tr>
    )
  }
}

export default OrderRow


// WEBPACK FOOTER //
// ./src/components/Orders/OrderRow.js